import { Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';

export const FutureMaturitiesItemMobile = ({ item, onSelectAccount }) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  return (
    <Shadow level={1} testId="shadow" borderRadius={BoxRadius.sm} margin={Spacing['inline.nano']}>
      <Box
        p={Spacing['inset.sm']}
        bgColor={Color['neutral.white']}
        borderRadius={BoxBorder.heavy}
        marginBottom={Spacing['inline.xxs']}>
        <VStack space={Spacing['inline.xxxs']}>
          <HStack justifyContent="space-between">
            <Pressable onPress={() => onSelectAccount(item.customerAccountNumber)}>
              <Text fontSize={Typography['fontsize.md']}>Cliente</Text>
              <Text fontSize={Typography['fontsize.md']}>
                {truncateText(item.customerNameNormalized, 30)}
              </Text>
            </Pressable>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Produto</Text>
            <VStack alignItems="end">
              <Text fontSize={Typography['fontsize.md']} variant="semibold">
                {item.productNameNormalized}
              </Text>
              <Text fontSize={Typography['fontsize.md']} color={'neutral.medium'}>
                {truncateText(item.productDescriptionNormalized, 30)}
              </Text>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between">
            <Text fontSize={Typography['fontsize.md']}>Valor</Text>
            <Text
              color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
              fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
              letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
              {valueVisibility
                ? Utils.Mask.Money(item.operationValueNormalized)
                : Typography['bullet.sequence']}
            </Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text fontSize={Typography['fontsize.md']}>Saldo</Text>
            <Text
              color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
              fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
              letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
              {valueVisibility
                ? Utils.Mask.Money(item.customerBalanceNormalized)
                : Typography['bullet.sequence']}
            </Text>
          </HStack>
        </VStack>
      </Box>
    </Shadow>
  );
};
